import { render, staticRenderFns } from "./PaletteEditForm.vue?vue&type=template&id=76447796"
import script from "./PaletteEditForm.vue?vue&type=script&lang=js"
export * from "./PaletteEditForm.vue?vue&type=script&lang=js"
import style0 from "./PaletteEditForm.vue?vue&type=style&index=0&id=76447796&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports